// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mathLive_jdyKq5jY math-field{padding:.5em;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.disabled_JAd57BAg math-field{background-color:#e9ecef}.inline_AtyOQ67n{display:inline-flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mathLive": "mathLive_jdyKq5jY",
	"disabled": "disabled_JAd57BAg",
	"inline": "inline_AtyOQ67n"
};
export default ___CSS_LOADER_EXPORT___;
